import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { useAssignManagerStore } from '../Store/hooks/useStore'
import { ASSIGN_MANAGER_ACTION } from '../uuid'

import { TransferManagerButtonProps } from './interface'

export const TransferManagerButton = ({
  record
}: TransferManagerButtonProps) => {
  const { setMembers, toggleAssignFormVisible } = useAssignManagerStore(state =>
    pick(state, ['setMembers', 'toggleAssignFormVisible'])
  )
  const handleTransfer = () => {
    setMembers([record])
    toggleAssignFormVisible()
  }

  return record.memberManagerId ? (
    <ActionButton
      type='link'
      uuid={ASSIGN_MANAGER_ACTION}
      onClick={handleTransfer}
    >
      划转
    </ActionButton>
  ) : null
}
